<div class="data-monitor-virtual-list-dev" ref="virtual_list_dev">

  <div class="table-filter checkbox-size-lg" ref="table_filter" @contextmenu.once="() => {showDebugButton ? showDebugButton() : logWrapper.log('not implement');}">
    <div class="table-filter-text">
      <b-form class="filter-form" autocomplete="off">
        <b-form-input v-model="filterTextList" :placeholder="$t('individual.label_data_monitor_filter')" type="text"
          id="filter-text-list" class="" size="sm" autocomplete="off" @input="handleUpdateFilter" />
      </b-form>
    </div>

    <b-button v-if="showDebug" @click="downloadTSV" style="margin: 5px 3px 0px 3px; width: 70px !important; height: 24px !important; font-size: 9px !important;">Download</b-button><!-- for debug -->

    <b-form-checkbox-group class="table-filter-checkboxes">
      <b-form-checkbox 
        v-model="filterCheckList[0]"
        size="sm"
        class="ml-2"
        @change="handleUpdateFilterCheck()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><path d="M0 0h24v24H0z" fill="none"/><path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"/></svg>
      </b-form-checkbox>
      <b-form-checkbox 
        v-model="filterCheckList[1]"
        size="sm" 
        class="ml-2"
        @change="handleUpdateFilterCheck()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><rect fill="none" height="24" width="24"/><path d="M2,19.99l7.5-7.51l4,4l7.09-7.97L22,9.92l-8.5,9.56l-4-4l-6,6.01L2,19.99z M3.5,15.49l6-6.01l4,4L22,3.92l-1.41-1.41 l-7.09,7.97l-4-4L2,13.99L3.5,15.49z"/></svg>
      </b-form-checkbox>
    </b-form-checkbox-group>
  </div>

  <div class="virtual-list-title" ref="virtual_list_title">
    <div v-for="column in columns" 
      :key="column.name" 
      :class="['title-row', getTitleStyle(column.name)]">
      <template v-if="column.label==='splitIconHeader'">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><path d="M0 0h24v24H0z" fill="none"/><path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"/></svg>
      </template>
      <template v-else-if="column.label==='unionIconHeader'">
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><rect fill="none" height="24" width="24"/><path d="M2,19.99l7.5-7.51l4,4l7.09-7.97L22,9.92l-8.5,9.56l-4-4l-6,6.01L2,19.99z M3.5,15.49l6-6.01l4,4L22,3.92l-1.41-1.41 l-7.09,7.97l-4-4L2,13.99L3.5,15.49z"/></svg>
      </template>
      <template v-else>
        {{ column.label }}
      </template>
    </div>
    <div v-show="isListScrolled" class="title-dummy">&nbsp;</div><!-- dummy -->
  </div>
  <virtual-list class="virtual-list"
    :ref="`${getVirtualListId()}-ref`"
    :id="getVirtualListId()"
    :data-key="'name'" 
    :data-sources="items" 
    :data-component="itemComponent"
    :keeps=60
    :extra-props="createListItemProps()"
  />
</div>
